import * as actionTypes from './actionTypes';

export const setAdmin = (isAdmin) => ({
    type: actionTypes.SET_ADMIN,
    isAdmin
});

export const toggleAdminMode = () => ({
    type: actionTypes.TOGGLE_ADMIN_MODE
});
